module.exports = "/images/no_documents_icon.svg?475e6334e1ded2d575fd0fdfd715f12d";